<template>
    <div class="step-1">
        <h2><trans msg="step1_title" /></h2>
        <p><trans msg="step1_description" /></p>
        <input ref="field" type="text" :class="invalid.indexOf('name') !== -1 && 'error' || null" @click="change_value" :value="name" @keyup="change_value" />
    </div>
</template>

<script>

import Translation from './Translation.vue'

export default {
  name: 'step-1',
  mounted: function() {
    this.$refs.field.focus();
  },
  props: ['name', 'invalid'],
  methods: {
    change_value: function(ev) {
        this.$emit('change_value', ev.target.value);
    }
  },
  components: {
    'trans': Translation
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// Step1.vue?5c096fda